import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero, Reveal, PhotoSlot, EmptyState, useSettings, siteText } from "@/components/shared";

export default function LeBar() {
  const settings = useSettings();
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    api
      .get("/gallery")
      .then((r) => setPhotos(r.data.filter((p) => p.category === "boissons")))
      .catch(() => setPhotos([]));
  }, []);

  return (
    <div data-testid="le-bar-page">
      <PageHero overline="Le Bar" title="Cocktails, vins & spiritueux" testId="le-bar-hero">
        <p data-testid="le-bar-intro">{siteText(settings, "bar_intro") || "Texte à venir."}</p>
      </PageHero>

      <section className="px-6 pb-28 md:px-12 md:pb-40">
        <div className="mx-auto max-w-6xl">
          {photos === null ? null : photos.length === 0 ? (
            <EmptyState text="Les photos du bar arrivent bientôt." />
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="bar-gallery-grid">
              {photos.map((photo, i) => (
                <Reveal key={photo.id} delay={(i % 3) * 0.08}>
                  <figure data-testid={`bar-gallery-item-${photo.id}`}>
                    <PhotoSlot src={photo.photo} alt={photo.caption} ratio="aspect-[3/4]" />
                    {photo.caption && (
                      <figcaption className="mt-3 text-xs uppercase tracking-[0.2em] text-ivory/40">
                        {photo.caption}
                      </figcaption>
                    )}
                  </figure>
                </Reveal>
              ))}
            </div>
          )}

          <Reveal className="mt-20 text-center">
            <p className="text-sm uppercase tracking-[0.25em] text-ivory/40">
              Cocktails, vins et champagnes
            </p>
            <Link to="/carte" className="btn-outline mt-8" data-testid="le-bar-carte-button">
              Découvrir la carte
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
